import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { PromptLibraryItem, UpsertPromptRequest } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function upsertPrompt(data: UpsertPromptRequest): Promise<PromptLibraryItem> {
  return api.post("/explorer/prompt", data)
}

export function useUpsertPrompt() {
  const queryClient = useQueryClient()

  const upsertPromptMutation = useMutation({
    mutationKey: queryKeys.upsertPrompt,
    mutationFn: (data: UpsertPromptRequest) => upsertPrompt(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.prompts })
    },
  })

  return upsertPromptMutation
}
